<template>
  <div>
    <Card>
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
          <Row>
              <Col span="11">
                <FormItem label="预付款比例" prop="AdvancePayment">
                    <Input type="number" v-model="formValidate.AdvancePayment" placeholder="输入预付款比例"></Input>
                </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label-width="10">
                    <div style="color:#17233d">（按百分比填写，如30%，则填写 30）</div>
                </FormItem>
              </col>
          </Row>
          <Row>
              <Col span="11">
               <FormItem label="公司网址">
                  <Input v-model="formValidate.CompanyWebsite" placeholder="请输入公司网址"></Input>
               </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label-width="10">
                    <div style="color:#17233d">（联系客服顶部公司网址）</div>
                </FormItem>
              </Col>
          </Row>
          <Row>
              <Col span="11">
               <FormItem label="确认订单提示">
                  <Input v-model="formValidate.SureTip" placeholder="请输入提示"></Input>
               </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label-width="10">
                    <div style="color:#17233d">（小程序确认订单界面下方的支付提示）</div>
                </FormItem>
              </Col>
          </Row>
          <Row>
              <Col span="11">
               <FormItem label="订单温馨提示">
                  <Input v-model="formValidate.OrderTip" placeholder="请输入提示"></Input>
               </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label-width="10">
                    <div style="color:#17233d">（小程序我的订单界面上方的温馨提示）</div>
                </FormItem>
              </Col>
          </Row>
          <Row>
              <Col span="11">
               <FormItem label="托盘单价" prop="TrayPrice">
                  <Input type="number" v-model="formValidate.TrayPrice" placeholder="请输入托盘单价"></Input>
               </FormItem>
              </Col>
              <Col span="11">
                <FormItem :label-width="10">
                    <div style="color:#17233d">（托盘单价不能为空，如没单价，请填写0）</div>
                </FormItem>
              </Col>
          </Row>
          <FormItem>
              <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
          </FormItem>
        </Form>
    </Card>
  </div>
</template>

<script>
import { MiscellaneousDataApi, ChangeMiscellaneous } from '../../../api/Miscellaneous'
export default {
  name: 'Miscellaneous',
  data () {
    const validateAdvancePayment = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写预付款百分比'))
      } else {
        callback()
      }
    }
    const validateTrayPrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写托盘单价'))
      } else {
        callback()
      }
    }
    return {
      formValidate: {
        AdvancePayment: 0,
        CompanyWebsite: '',
        SureTip: '',
        OrderTip: '',
        TrayPrice: 0
      },
      apilist: [],
      ruleValidate: {
        AdvancePayment: [{ validator: validateAdvancePayment, trigger: 'blur' }],
        TrayPrice: [{ validator: validateTrayPrice, trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    this.GetMiscellaneousData()
  },
  methods: {
    // 获取杂项设置数据
    GetMiscellaneousData () {
      MiscellaneousDataApi().then(res => {
        if (res.IsSuccess) {
          this.apilist = res.Data
          this.formValidate.AdvancePayment = this.apilist[0].value
          this.formValidate.CompanyWebsite = this.apilist[1].value
          this.formValidate.SureTip = this.apilist[2].value
          this.formValidate.OrderTip = this.apilist[3].value
          this.formValidate.TrayPrice = this.apilist[4].value
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let lists = []
          const list1 = {
            id: this.apilist[0].ID,
            value: this.formValidate.AdvancePayment
          }
          const list2 = {
            id: this.apilist[1].ID,
            value: this.formValidate.CompanyWebsite
          }
          const list3 = {
            id: this.apilist[2].ID,
            value: this.formValidate.SureTip
          }
          const list4 = {
            id: this.apilist[3].ID,
            value: this.formValidate.OrderTip
          }
          const list5 = {
            id: this.apilist[4].ID,
            value: this.formValidate.TrayPrice
          }
          lists.push(list1)
          lists.push(list2)
          lists.push(list3)
          lists.push(list4)
          lists.push(list5)
          ChangeMiscellaneous({
            list: lists
          }).then((res) => {
            if (res.IsSuccess) {
              this.$Message['success']({
                background: true,
                content: '提交成功'
              })
            } else {
              this.$Message.error(res.Message)
            }
          })
        } else {
          this.$Message.error('Fail!')
        }
      })
    }
  }
}
</script>
